<h1 mat-dialog-title>Validación</h1>

<div mat-dialog-content class="dialog-content">
    <!-- COLUMNA IZQUIERDA -->
    <div class="left-column" [class.full-width]="!(data && data.validation)">
        <h3 *ngIf="data && data.validation">
            Transacción-Autorización: {{ authorizationNumber }}
        </h3>

        <div *ngIf="!isPreadmission && (!data || !data.validation)" class="authorization-input">
            Transacción-Autorización:
            <input type="text" [(ngModel)]="authorizationNumber" class="auth-input" />
        </div>

        <ng-container *ngIf="procedures && proceduresWithAmount.length > 0; else noProcedures">
            <ul class="procedure-list">
                <li *ngFor="let p of proceduresWithAmount" [class.procedure-error]="data && data.validation && !p.IsOk">
                    <div class="procedure-header">
                        <span>
              <strong>{{ p.Code }}</strong> – {{ p.Name }}
            </span>

                        <input *ngIf="!data || !data.validation" type="checkbox" [(ngModel)]="p.IsOk" />

                        <!-- ❌ reglas aplicadas (solo visual) -->
                        <span *ngIf="p.AppliedRulesIds && p.AppliedRulesIds.length > 0" class="rule-cross" title="Tiene reglas aplicadas">
              ✖
            </span>
                    </div>

                    <div class="procedure-message" *ngIf="p.Message">
                        {{ p.Message }}
                    </div>
                </li>
            </ul>
        </ng-container>

        <ng-template #noProcedures>
            <span class="empty-text">No hay prácticas pendientes</span>
        </ng-template>
    </div>

    <!-- COLUMNA DERECHA -->
    <div class="right-column" *ngIf="data && data.validation" [class.message-error]="isNoOk" [class.message-ok]="!isNoOk">
        {{ displayMessage }}
    </div>
</div>

<div mat-dialog-actions align="end">
    <button type="button" mat-button cdkFocusInitial (click)="onNoOkClick()">
    ACEPTAR
  </button>
</div>